// extracted by mini-css-extract-plugin
export default {"heading":"Register_heading__om6rv"};